import React from 'react';
import './Loader.css';

// Full-screen loader with orbital hex rings
export default function Loader({ label = 'LOADING' }) {
  return (
    <div className="loader-overlay">
      <div className="loader-inner">
        <div className="loader-hex loader-hex-1" />
        <div className="loader-hex loader-hex-2" />
        <div className="loader-hex loader-hex-3" />
        <div className="loader-core">
          <img src="/logos/xterra-icon.png" alt="X-Terra" />
        </div>
        <div className="loader-label">{label}</div>
      </div>
    </div>
  );
}

// Inline button spinner
export function Spinner({ size = 'sm' }) {
  return <span className={size === 'lg' ? 'spinner spinner-lg' : 'spinner'} />;
}

// Three-dot inline loader
export function DotLoader() {
  return (
    <span className="dot-loader">
      <span /><span /><span />
    </span>
  );
}

// Big in-page loader with animated Xterra icon — for page-level loading states
export function PageLoader({ label = 'LOADING', sub = null }) {
  return (
    <div className="page-loader">
      <div className="page-loader-icon-wrap">
        <div className="page-loader-ring r1" />
        <div className="page-loader-ring r2" />
        <div className="page-loader-ring r3" />
        <div className="page-loader-orbit">
          <div className="dot d1" />
          <div className="dot d2" />
          <div className="dot d3" />
          <div className="dot d4" />
        </div>
        <div className="page-loader-icon">
          <img src="/logos/xterra-icon.png" alt="X-Terra" />
        </div>
      </div>
      <div className="page-loader-text">{label}</div>
      {sub && <div className="page-loader-sub">{sub}</div>}
    </div>
  );
}
